import { modelHelperModule } from './model-helper';

export const webhookSubscriptionModelModule = angular
  .module('Q.models.webhookSubscription', [modelHelperModule])

  .factory('WebhookSubscription', function (ModelHelper) {
    return ModelHelper.defineResource({
      name: 'WebhookSubscription',
      endpoint: 'webhook_subscriptions',

      relations: {
        belongsTo: {
          Team: {
            localField: 'team',
            localKey: 'teamId',
          },
        },
      },
    });
  });
